/* eslint-disable no-underscore-dangle */
import React from 'react'

// Lazy loading
import loadable from '@loadable/component'

// First-fold: keep the banner in the main bundle so the LCP image is in the initial HTML
import BannerShell from 'components/flex/Banner/Shell'

interface FlexContentProps {
  prefix?: string
  fields: any
  location?: any
}

interface FlexerProps {
  [key: string]: any
}

interface ComponentProps {
  fields: any
  location?: any
}

const FlexContentHandler: React.FC<FlexContentProps> = ({
  prefix = 'page_Flexcontent',
  fields,
  location = {},
}) => {
  if (!fields) {
    return null
  }

  const flexers: FlexerProps = {
    [`${prefix}_Flex_Banner`]: BannerShell,
    [`${prefix}_Flex_Form`]: loadable(
      () => import('components/flex/Form/Shell')
    ),
    [`${prefix}_Flex_Text`]: loadable(
      () => import('components/flex/Text/Shell')
    ),
    [`${prefix}_Flex_Services`]: loadable(
      () => import('components/flex/Services/Shell')
    ),
    [`${prefix}_Flex_Partners`]: loadable(
      () => import('components/flex/Misc/Partners')
    ),
    [`${prefix}_Flex_Usp`]: loadable(() => import('components/flex/Misc/Usp')),
    [`${prefix}_Flex_ProjectMap`]: loadable(
      () => import('components/flex/Misc/ProjectMap')
    ),
    [`${prefix}_Flex_PostTypes`]: loadable(
      () => import('components/flex/Posts/Overview/Shell')
    ),
    [`${prefix}_Flex_LatestPostTypes`]: loadable(
      () => import('components/flex/Posts/Latest/Shell')
    ),
    [`${prefix}_Flex_Gallery`]: loadable(
      () => import('components/flex/Gallery')
    ),
    [`${prefix}_Flex_HighlightedPostTypes`]: loadable(
      () => import('components/flex/Posts/Highlighted/Shell')
    ),
    [`${prefix}_Flex_Fragment`]: loadable(
      () => import('components/flex/Misc/Fragment')
    ),
    [`${prefix}_Flex_Faq`]: loadable(() => import('components/flex/FAQ')),
  }

  if (!fields.flex) {
    return null
  }

  return (
    <>
      {fields.flex.map((section: any, index: number) => {
        if (!section.fieldGroupName || !flexers[section.fieldGroupName]) {
          return null
        }

        const Component: React.FC<ComponentProps> =
          flexers[section.fieldGroupName]

        return (
          <Component
            // eslint-disable-next-line react/no-array-index-key
            key={`${location ? location.pathname : 'flex'}-${index}`}
            fields={section}
            location={location}
          />
        )
      })}
    </>
  )
}

export default FlexContentHandler
